// src/features/dashboard/components/MobileReportsMenu.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Receipt, 
  TrendingUp, 
  CreditCard, 
  FileText,
  ChevronRight
} from 'lucide-react';

const ReportTypesPage = () => {
  const navigate = useNavigate();

  const reportOptions = [
    {
      title: 'Expense Reports',
      description: 'Track and manage all your expenses',
      icon: <Receipt size={24} className="text-blue-600" />,
      color: 'bg-blue-50',
      path: '/dashboard/expense-reports'
    },
    {
      title: 'Revenue Reports',
      description: 'Monitor your income and revenue streams',
      icon: <TrendingUp size={24} className="text-green-600" />,
      color: 'bg-green-50',
      path: '/dashboard/revenue-reports'
    },
    {
      title: 'Bills',
      description: 'Manage recurring payments and bills',
      icon: <CreditCard size={24} className="text-purple-600" />,
      color: 'bg-purple-50',
      path: '/dashboard/bills'
    },
    {
      title: 'Proformas',
      description: 'Create and track proforma invoices',
      icon: <FileText size={24} className="text-orange-600" />,
      color: 'bg-orange-50',
      path: '/dashboard/proformas'
    }
  ];

  return (
    <div className="md:hidden">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Reports</h1>
        <p className="text-gray-500">Select a report type to continue</p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {reportOptions.map((option, index) => (
          <button
            key={index}
            onClick={() => navigate(option.path)}
            className={`p-4 rounded-lg border border-gray-200 shadow-sm flex items-center ${option.color} hover:shadow-md transition-shadow duration-200`}
          >
            <div className="bg-white rounded-full p-3 mr-4 shadow-sm">
              {option.icon}
            </div>
            <div className="flex-1 text-left">
              <h3 className="font-medium text-gray-900">{option.title}</h3>
              <p className="text-sm text-gray-500">{option.description}</p>
            </div>
            <ChevronRight className="h-5 w-5 text-gray-400" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportTypesPage;